import React from "react";

interface Props {}

const SideNavbar = (props: Props) => {
    return <div></div>;
};

export default SideNavbar;
